export { default as GDMFormHelperText } from './GDMFormHelperText';

export type { GDMFormHelperTextComponent, GDMFormHelperTextProps } from './GDMFormHelperText.type';
